<div class="flex flex-col w-full justify-center items-center pt-[20vh] gap-4">
  <div class="text-6xl">
    <pm-icon [icon]="lock" size="sm"></pm-icon>
  </div>
  <h1 class="text-2xl">{{ 'LAYOUT.ACCESS_DENIED' | translate }}</h1>
  <div class="textl-lg">{{ 'LAYOUT.ACCESS_DENIED_HINT' | translate }}</div>
</div>
